module.exports = __webpack_public_path__ + "img/Modernisme_Tanker_i_tida4.310c9e8d.jpg";